import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const dropdownMenuItemVariantList = {
  color: {
    default: '',
    destructive: '',
  },
  variant: {
    solid: '',
    outline: '',
  },
  size: {
    sm: 'h-8 px-2 text-sm',
    md: 'h-9 px-3 text-base',
    lg: 'h-10 px-4 text-lg',
  },
}

export const dropdownMenuItemVariants = cva(
  'relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-neutral-100 focus:text-neutral-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-neutral-800 dark:focus:text-neutral-50',
  {
    variants: dropdownMenuItemVariantList,
    compoundVariants: [
      {
        color: 'destructive',
        variant: 'solid',
        class: 'text-red-500 hover:!bg-red-50 hover:!text-red-600 focus:!bg-red-50 focus:!text-red-600',
      },
      {
        color: 'destructive',
        variant: 'outline',
        class: 'border border-error-600 text-error-600 hover:bg-error-50',
      },
    ],
  },
)

export type DropdownMenuItemVariants = VariantProps<typeof dropdownMenuItemVariants>

export const dropdownMenuContentClasses = 'z-50 min-w-32 overflow-hidden rounded-md border border-neutral-200 bg-white p-1'
  + ' text-neutral-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out'
  + ' data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95'
  + ' data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2'
  + ' data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-neutral-800'
  + ' dark:bg-neutral-950 dark:text-neutral-50'
